import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
// import {usermodel} from '@/model/models'
Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    userstate:null,
    token:'',
    routerState:'',
    shopInfo:{},
    competition:null
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
        
    },
    DECREMENT(state) {
        state.count--
    },
    ChangeRouterState(state,value)
    {
       state.routerState=value;
    },
    ADD_LOGIN_USER (state,data) {  //登入，保存状态
        // sessionStorage.setItem("username", data);  //添加到sessionStorage
        // sessionStorage.setItem("isLogin",true);
      
        state.userstate=data , 
        state.token=JSON.parse(data).DreamToken          //同步的改变store中的状态
        // state.isLogin=true
        // console.log(state);
    },
    SetShopInfo(state,data)
    {
      
        state.shopInfo=data
    },

    Setcompetition(state,data)
    {
      
        sessionStorage.setItem("competition",data);
        state.competition=data;
    },
    SIGN_OUT (state) {   //退出，删除状态
        sessionStorage.removeItem("user");  //移除sessionStorage
       
        // sessionStorage.removeItem("isLogin");
        // state.username=''                //同步的改变story中的状态
        // state.isLogin=false
        state.userstate=null;
        state.token=''
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js